import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "right",
  "use": "right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"right\"><defs><style></style></defs><path d=\"M726.4 534.4l-384 384c-12.8 12.8-32 12.8-44.8 0-12.8-12.8-12.8-32 0-44.8L659.2 512 297.6 150.4c-12.8-12.8-12.8-32 0-44.8 12.8-12.8 32-12.8 44.8 0l384 384c6.4 6.4 9.6 16 9.6 22.4 0 9.6-3.2 16-9.6 22.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol